export const sideBarAuthDashboard = {
  AuthSideBarMenuProccess: "AUTH.SIDEBAR_MENU_PROCCESS",
  AuthSideBarMenuSIGISS: "AUTH.SIDEBAR_MENU_SIGISS",
}
